/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/
import Vue from 'vue'
const moment = require('moment') // require

const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp                 = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR (state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME (state, val)           { state.theme             = val   },
  UPDATE_WINDOW_WIDTH (state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }


    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SetTokens (state, payload) {
    state.tokens.accessToken = payload.accessToken
    state.tokens.idToken = payload.idToken
    
  },
  SetSimulation (state, payload) {
    state.simulation = payload
  },
  SetIsSimulation (state, payload) {
    state.isSimulation = !!payload
  },
  SetIsEveryone (state, payload) {
    state.isEveryone = payload
  },
  SetUserProfileImage (state, payload) {
    state.photoURL = payload
  },

  SetUserLoggedInStatus (state, payload) {
    state.userLoggedIn = payload
  },
  
  SetTimeEntryList (state, payload) {
    const f = 'YYYY-MM-DD hh:mm A'
    payload = payload.sort((a, b) => (moment(a.TimeIn, f).isBefore(moment(b.TimeIn, f))) ? 1 : -1)

    state.timeEntryList = state.exampleTimeEntryList
    state.timeEntryList = payload
  },

  SetCategoryList (state, payload) {
    state.categoryList = payload
  },

  SetCategoryListSOW (state, payload) {
    if (state.categoryList.find(x => x.CategoryID == payload[0].CategoryID) == null) {
      state.categoryList.push(payload[0])
    }
    // state.categoryListSOW = payload
  },

  SetClientList (state, payload) {
    state.clientList = payload
  },
  SetClientCategoryList (state, payload) {
    state.clientCategoryList = payload.data.Categories
  },
  SetWorkerList (state, payload) {
    state.workerList = payload
  },
  ConnectWorkerToJira (state, payload) {},
  SetMonthlyTable (state, payload) {
    state.monthlyTable = payload
  },
  SetQuarterlyData (state, payload) {
    state.quarterlyData = payload
  },
  
  SetNewProject (state, payload) {
    state.projectList.push(payload)
  },
  SetUpdateProject (state, payload) {
    for (let i = 0; i < state.projectList.length; i++) {
      if (state.projectList[i].ITATInfo.ProjectID == payload.ProjectID) {
        state.projectList[i].ITATInfo = payload
      }
    }
  },

  SetTaskStatusLookups (state, payload) {
    state.taskStatusLookups = payload
  },

  SetSOWStatusLookups (state, payload) {
    state.sowStatusLookups = payload
  },

  SetSOWOverageStatusLookups (state, payload) {
    state.sowOverageStatusLookups = payload
  },
  // SetWorkerTaskList (state, payload) {
  //   state.workerTaskList = payload
  // },
  // SetNewTask (state, payload) {
  //   payload.Task = `${payload.TaskGroup  } - ${  payload.TaskName}`
  //   state.taskList.push(payload)
  //   console.log(state.taskList)
  // },
  SetUpdateTask (state, payload) {
    //payload.Task = payload.TaskGroup + " - " + payload.TaskName
    for (let i = 0; i < state.taskList.length; i++) {
      if (state.taskList[i].ITATInfo.TaskID == payload.TaskID) {
        Object.assign(state.taskList[i].ITATInfo, payload)
        // state.taskList[i].ITATInfo = payload
        //Vue.set(state.taskList, i, payload)
      }
    }
  },
  SetDevOpsReleaseDefs(state, payload) {
    state.devOpsReleaseDefs = payload
  },
  // /////////////////////////////////////////////
  // Time Entries
  // /////////////////////////////////////////////
  SetNewTimeEntry (state, payload) {
    state.timeEntryList.unshift(payload)
  },

  SetTimeEntry (state, payload) {
    for (let i = 0; i < state.timeEntryList.length; i++) {
      if (state.timeEntryList[i].RecordID == payload.RecordID) {
        Vue.set(state.timeEntryList, i, payload)
      }
    }
  },

  SetTimeEntryRemoved (state, payload) {
    for (let i = 0; i < state.timeEntryList.length; i++) {
      if (state.timeEntryList[i].RecordID == payload.RecordID) {
        Vue.delete(state.timeEntryList, i)
      }
    }
  },

  SetModalData (state, payload) {
    state.modals[payload.modal].content.header = payload.header
    state.modals[payload.modal].content.details = payload.details
    state.modals[payload.modal].content.body = payload.body
    state.modals[payload.modal].content.details = payload.details
    state.modals[payload.modal].callbackFunction = payload.callback
  },
  SetOpenCloseModal (state, payload) {
    state.modals[payload.modal].show = payload.show
  },
  SetReceivedGlobalData (state, payload) {
    state.receivedGlobalData = payload
  },
  SetTimeEntryPrompt (state, payload) {
    payload.tick = Date.now()
    console.log('set time entry prompt', payload)
    if (payload.task == null || payload.task == 'undefined') {
      payload.task = {}
      payload.task = null
    }
    // state.timeEntryPrompt = 
    Vue.set(state, 'timeEntryPrompt', Object.assign(state.timeEntryPrompt, payload))
    state.timeEntryPromptTick = payload.tick
  },
  SetCurrentTimeEntry (state, payload) {
    state.currentTimeEntry = payload
  },
  SetSubTimeEntry (state, payload) {
    state.subTimeEntry = payload
  },
  SetIsAdmin (state, payload) {
    state.isAdmin = payload
  },
  IncActiveRequests (state) {
    state.activeRequests += 1
  },
  DecActiveRequests (state) {
    state.activeRequests = Math.max(0, state.activeRequests - 1)
  },
  SetDevOpsPAT (state, payload) {
    state.devOpsPAT = payload
  },
  SetWorkerID (state, payload) {
    state.workerID = payload
  },
  SetAuthWorkerID (state, payload) {
    state.authWorkerID = payload
  },
  SetIsClient (state, payload) {
    state.isClient = payload
    state.isWorker = !payload
  },
  SetClient (state, payload) {
    for (let i = 0; i < state.clientList.length; i++) {
      if (state.clientList[i].ClientID == payload.ClientID) {
        Vue.set(state.clientList, i, payload)
      }
    }
  },
  DeleteClient (state, id) {},

  SetRawTotalHoursWorked (state, payload) {
    var newPayload = []

    for(var i = 0; i < payload.length; i++){
      var entry = newPayload.find(x => x.ClientID == payload[i].ClientID)
      if(entry == null){
        entry = payload[i]
        newPayload.push(entry)
      }else{
        entry.HoursWorked += payload[i].HoursWorked
      }
    }

    state.rawTotalHoursWorked = newPayload 
  },
  
  SetBillableWeeklyWorked(state, payload) {
    state.billableWeeklyWorked = payload
  },

  SetRawTotalHoursWorkedWeekly (state, payload) {
    var newPayload = []
    let totalMileage = 0
    for(var i = 0; i < payload.length; i++){
      totalMileage += payload[i].TotalMileage
      var entry = newPayload.find(x => x.ClientID == payload[i].ClientID)
      if(entry == null){
        entry = payload[i]
        newPayload.push(entry)
      }else{
        entry.HoursWorked += payload[i].HoursWorked
      }
    }
    state.rawTotalHoursWorkedWeekly = newPayload 
    state.weeklyMileage = totalMileage
  },

  
  //
  // PROJECTS
  //

  SetProjectList (state, payload) {
    state.projectList = payload
  },
  SetSelectedProjectID (state, payload) {
    state.selectedProjectID = payload
  },
  SetSOWSelectedTasks(state, payload) {
    state.sowSelectedTasks = payload
  },
  SetTask(state, payload) {
    for (let i = 0; i < state.taskList.length; i += 1) {
      const task = state.taskList[i]
      if (task.id === payload.id) {
        task.fields.timespent = (payload.fields.timespent || 0) / 60.0 / 60.0
      }
    }
  },
  SetMyTaskList(state, payload) {
    state.myTaskList = payload
  },
  SetAllTaskList(state, payload) {
    state.allTaskList = payload
  },
  SetTaskComplete(state, payload) {
    const date = (new Date()).toISOString()
    const setComplete = (list) => {
      const byTask = payload.taskId != null ? list.find(x => x.TaskID == payload.taskId) : null
      const bySow = payload.sowLineItemId != null ? list.find(x => x.SOWLineItemID == payload.sowLineItemId) : null
      if (byTask) byTask.CompleteDate = date
      if (bySow) bySow.CompleteDate = date
    }
    setComplete(state.myTaskList)
    setComplete(state.allTaskList)
  },
  SetTaskList (state, payload) {
    const { tasks } = payload
    for(var i = 0; i < tasks.length; i++){
      var task = tasks[i]
      // task.ITATInfo.EstimatedHours = (task.ITATInfo.EstimatedHours / 60) / 60
      task.fields.timeoriginalestimate = task.fields.timeoriginalestimate / 60 / 60
      task.flagged = task.fields.customfield_10021 != null
    }
    state.taskList = tasks
    // state.epicList = epics
  },
  SetTaskListUncompleted(state, payload) {
    const { tasks } = payload
    for(var i = 0; i < tasks.length; i++){
      var task = tasks[i]
      task.fields.timeoriginalestimate = task.fields.timeoriginalestimate / 60 / 60
      task.flagged = task.fields.customfield_10021 != null
    }
    state.taskListUncompleted = tasks
  },
  SetTaskListAll (state, payload) {
    const tasks = payload
    for(var i = 0; i < tasks.length; i++){
      var task = tasks[i]
      // task.ITATInfo.EstimatedHours = (task.ITATInfo.EstimatedHours / 60) / 60
      task.fields.timeoriginalestimate = task.fields.timeoriginalestimate / 60 / 60
      task.flagged = task.fields.customfield_10021 != null
    }
    state.taskListAll = tasks
    // state.epicList = epics
  },
  SetDeleteProject (state, payload) {
    for (let i = 0; i < state.projectList.length; i++) {
      if (state.projectList[i].ProjectID == payload) {
        state.projectList.splice(i, 1)
        break
      }
    }
  },
  SetProjectStatuses(state, payload){
    state.projectStatuses = payload
  },
  SetPotentialExternalTask(state, payload){
    state.potentialExternalTask = payload
  },
  SetPotentialTaskToMine(state, payload){
    if(state.potentialExternalTask != null){
      var localTask = state.taskList.find(x => x.ITATInfo.TaskID == state.potentialExternalTask.ITATInfo.TaskID)
      // Vue.set(localTask.ITATInfo, "WorkerID", payload.ITATInfo.WorkerID)
      localTask.ITATInfo.WorkerID = state.workerID
      state.potentialExternalTask = null
    }
  },

  //
  // Daily Time Page
  //

  SetStatsHours (state, payload) {
    state.statsHours = payload
  },

  SetWorkerMessages (state, payload) {
    state.workerMessages = payload
  },
  SetJiraDomain (state, payload) {
    state.jiraDomain = payload
  },
  SetSOWList (state, payload) {
    state.sowList = payload
  },
  SetMySOWLineItems(state, payload) {
    state.mySOWLineItems = payload
  }

}


export default mutations

